import React from "react";
import PropTypes from "prop-types";
import { TableCell } from "investira.react.components";
import { validators } from "investira.sdk";
import { FormatNumber } from "../";

const NumberTableCell = (props) => {
  const {
    sufix = "",
    placeholder = "---",
    value,
    ...restFormatNumberProps
  } = props;

  return (
    <TableCell sx={{ textAlign: "right" }}>
      {!validators.isEmpty(value) ? (
        <FormatNumber value={value} {...restFormatNumberProps} sufix={sufix} />
      ) : (
        placeholder
      )}
    </TableCell>
  );
};

NumberTableCell.propTypes = {
  value: PropTypes.number,
  decimal: PropTypes.number,
  separateThousand: PropTypes.bool,
  showCurrency: PropTypes.bool,
  sufix: PropTypes.string,
  //placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element, PropTypes.node, PropTypes.func])
};

export default NumberTableCell;
